import Vue from 'vue'
import Vuex from 'vuex'
import {errorHandler} from "@/services/errorHandler";
import axios from "axios";

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        depots: {
            kafue: [
                "Barlastone",
                "Checkpoint",
                "Chilanga",
                "Chongwe",
                "Garden",
                "Ibex",
                "Kamanga",
                "Kamwala South",
                "Makeni Villa",
                "Meanwood",
                "Mimosa",
                "Showgrounds",
                "Waterfalls",
                "Woodlands"
            ],
            copperbelt: [
                "Chililabombwe",
                "Jacaranda",
                "Kalulushi Town",
                "Kasama",
                "Mansa",
                "Pamodzi",
                "Riverside"
            ],
        },
        // apiKey: '5c685245-70eb-4eea-994c-6a333085ec7f'//test
        // apiKey: '744ddfre-55eedff69-qzzwd2'//live
    },
    getters: {
        getApiKey: state => state.apiKey,
        getDepots: state => state.depots,
    },
    mutations: {},
    actions: {
        createTransaction: async (context, payload) => {
            let url = `${gatewayv2}GateWay/createOrder`;
            return await context.dispatch('sendRequest',{url,payload})
                .then(async (data) => data.url)
        },
        getBranches: (context,id) => {
            return axios.get(gateway + `regions/getBranchesByRegion?regionId=${id}&archived=false`)
                .then(({data}) => data )
                .catch((err) => errorHandler.tomcatError(err));
        },
        getRegions: (context) => {
            const apiKey = context.getters.getApiKey;
            return axios.get(gateway + `regions/getByApiKey?apiKey=${apiKey}&archived=false`)
                .then(async ({data}) => data )
                .catch((err) => errorHandler.tomcatError(err));
        },
        sendRequest(context, {url, payload, headers, method=`post`}) {
            const maxRetries = 3;
            let currentRetry = 0;
            if (!payload.localid){
                payload.localid = generateUUID();
            }

            const attemptRequest = () => {
                return axios[method](url, payload, {
                    headers: headers || {}
                }).then(({data}) => {
                    if (!data.processed) {
                        // Check if the response indicates unprocessed data and if retries are available
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Data unprocessed, retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                        // Throw an error if max retries are reached with unprocessed data
                        throw new Error('Data still unprocessed after maximum retries : ' + maxRetries);
                    }
                    return data.response; // Return the response if data is processed
                }).catch(err => {
                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                        if (currentRetry < maxRetries) {
                            currentRetry++;
                            console.log(`Attempt ${currentRetry}: Retrying...`);
                            return attemptRequest(); // Retry the request
                        }
                    }
                    throw err; // Re-throw the error if it's not a timeout or retries are exhausted
                });
            };
            return attemptRequest()
                .then(response => {
                    payload.localid = null

                    // Farm Depot: save cart to Chicken Little API keyed by the
                    // GATEWAY-assigned UUID (response.ID), not our localid.
                    // The gateway never stores client-supplied references in any
                    // DB column, so the cart has to be keyed by what the gateway
                    // DOES store — the row's `id` column. Reports.getTransactionHistory
                    // JOINs the cart table on gateway.id, which is now response.ID.
                    // Fire-and-forget: failure must not block the redirect to payment.
                    if (response && response.ID && Array.isArray(payload.cartItems) && payload.cartItems.length > 0) {
                        fetch(`${window.ChickenLittle}api/v2/stock/order-cart`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Api-Key': payload.apikey || ''
                            },
                            body: JSON.stringify({
                                localId: response.ID,
                                companyId: payload.apikey,
                                locationId: payload.locationId,
                                locationName: payload.locationName,
                                cart: payload.cartItems
                            })
                        }).catch(err => console.warn('[FD] order-cart post-call failed:', err));
                    }

                    return response
                })
                .catch(err => errorHandler.tomcatError(err));
        }
    },
    modules: {
    }
})
export default store;

